@import "igws-ls.less";

.ls__styled {
  padding: 3px 5px 3px 17px;

  &:after {
    left: 5px;
  }
}
.ls__options {
  left: 0;
}
.ls__option {

  &:before {
    content: "";
    width: 8px;
    height: 8px;
    display: inline-block;
    padding-left: 5px;
    background-image: @ls-arrow-grey;
    background-repeat: no-repeat;
    transform: rotate(180deg);
  }

  &:hover:before,
  &.active:before {
    background-image: @ls-arrow-dark;
  }
}
